import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';

@Component({
  selector: 'app-portal-detail-section',
  templateUrl: './portal-detail-section.component.html',
  styleUrls: ['./portal-detail-section.component.scss'],
})
export class PortalDetailSectionComponent {
  @Input() title = '';
  @Input() open = true;
  @Input() sectionClass = '';
  @Output() toggle = new EventEmitter<void>();

  @HostBinding('class')
  get hostClass(): string {
    return ['portal-detail-section-host', this.sectionClass].filter(Boolean).join(' ');
  }
}
